import angular = require("angular");
import TPL = require("templates");

export class Indicator {

  id: number;
  name: string;
  notificationCount: number;


  static idGen = 0;
  static createDummyIndicator(): Indicator {
    var result = new Indicator();
    result.id = Indicator.idGen++;
    result.name = "name" + result.id.toString();
    result.notificationCount = 4;

    return result;
  }
}


export class IndicatorList extends Array<Indicator> {

  static buildIndicatorList(): IndicatorList {
    var result = new IndicatorList();

    //result.push(Indicator.createDummyIndicator());
    //result.push(Indicator.createDummyIndicator());

    return result;
  }

  constructor() {
    super();
  }
}


export class IndicatorListDirective {

  template;
  link;
  scope = {};

  constructor() {
    this.template = TPL.navigationDirectives.indicatorList;

    this.link = (scope, el, attrs)=> {
        scope.vm = {
          indicatorList: IndicatorList.buildIndicatorList()
        };
    }
  }

  static factory() {
    var tmp = () => new IndicatorListDirective();
    return tmp;
  }

}

export class IndicatorDirective {

  scope = {
    item: "=item"
  };
  template;

  constructor() {
    this.template = TPL.navigationDirectives.indicator;
  }

  static factory() {
    var tmp = () => new IndicatorDirective();
    return tmp;
  }
}



/** WEBPACK FOOTER **
 ** ./src/scripts/directives/navigation/indicator.ts
 **/